import React, { useContext } from "react";
import CategoryButton from "./CategoryButton";
import { TranslateContext } from "../../App";

function CategoryButtons({ categories }) {
  const language = useContext(TranslateContext).language;
  return categories.map((category) => {
    return <CategoryButton url={category.slug} title={category.title[language]} color={category.color.hex} />;
  });
}

export default CategoryButtons;
